import { inject } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivateChildFn,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from '../services/auth.service';

export const CertificateGuard: CanActivateChildFn = (
  childRoute: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
):
  | Observable<boolean | UrlTree>
  | Promise<boolean | UrlTree>
  | boolean
  | UrlTree => {
  let [zero, first] = state.url.split('/');
  let auth = inject(AuthService);
  let router = inject(Router);
  if (!auth.me) {
    return false;
  } else {
    const { ruoli, certificato } = auth.me;
    //TO DO: PATH/USER ROLE MATCH CHECKS
    let needsCertificate =
      (ruoli?.includes('Responsabile') || ruoli?.includes('Addetto')) &&
      (!certificato?.alias || new Date(certificato.dataScadenza!) < new Date());

    if (needsCertificate) {
      return first === 'employee-id' || router.createUrlTree(['/employee-id']);
    } else {
      return (
        first === 'pratica' ||
        first === 'home' ||
        router.createUrlTree(['home'])
      );
    }
  }
};
